import { render, staticRenderFns } from "./TemplateMsgAlert.vue?vue&type=template&id=5b019a81&scoped=true&"
import script from "./TemplateMsgAlert.vue?vue&type=script&lang=js&"
export * from "./TemplateMsgAlert.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMsgAlert.vue?vue&type=style&index=0&id=5b019a81&lang=scss&scoped=true&"
import style1 from "./TemplateMsgAlert.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b019a81",
  null
  
)

export default component.exports